'use strict';
require('rc-slider/assets/index.css');

import React from 'react';
import SliderMark from 'components/clarity-ui/components/slider/mark'
import Slider from 'rc-slider';

class ThumbnailSlider extends React.Component {

  render () {
    const { sliderMark, ...otherProps } = this.props;
    return (
      <div className="ThumbnailSlider">
        <div className="Grid-cell--1of12"/>
        <div className="Grid-cell--8of12">
          <Slider {...otherProps} tipFormatter={null}/>
        </div>
        <div className="Grid-cell--3of12">
          <SliderMark>
            { sliderMark }
          </SliderMark>
        </div>
      </div>
    );
  }
}

export default ThumbnailSlider;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/thumbnail/thumbnailSlider.jsx